import {TAB_YEAR, TAB_CITY, TAB_LIFER, TAB_OBS_COUNT, TAB_CITY_MISSING} from '../stats/StatsCommon.js';
import React, {createContext, useContext} from 'react';
import {useLocalObservable} from 'mobx-react';
import {action, observable} from 'mobx';
import { DateTime } from 'luxon';
import {isoDStr, unixNow, EM_SELF, EM_OTHER, CITY_ID_FORSSA, COUNTRY_ID_NO, COUNTRY_ID_FI} from '../Util.js';
import {defaultFilter} from '../search/SearchDialog.js';
import {MTI_JPG, MTI_PNG} from '../taxons/TaxMedia.js';
import {LOCT_UNDEF} from '../Locations.js';
import {getCoordStr} from '../Geoloc.js';

const GlobalContext = createContext(null);

function createGlobalStorage() {
	function cleanElem(e) {
		if (e.t_id < 4 || e.t_id > 14) {
			e.value = 0;
			e.o_id = 0;
			e.val_obj = null;
		} else if (e.t_id === 10) {
			e.val_obj = DateTime.fromSeconds(e.value);
			console.log('date 10', e.value, e.val_obj);
		} else if (e.t_id === 11 || e.t_id === 12) {
			let m = (e.value >> 8) & 0xff;
			let d = e.value & 0xff;

			if (m < 1) {
				m = 1;
			} else  if (m > 12) {
				m = 12;
			}

			if (d < 1)
				d = 1;

			if (m === 2) {
				if (d > 29) {
					d = 29;
				}
			} else if (m === 4 || m === 6 || m === 9 || m === 11) {
				if (d > 30) {
					d = 30;
				}
			} else {
				if (d > 31)
					d = 31;
			}

			e.value = (m << 8) | d;
			e.val_obj = {month: m, day: d};
			console.log('e.t_id', e.t_id, e.value, e.val_obj);
		} else if (e.t_id === 13) {
			e.value = e.value % (24 * 3600);
			e.val_obj = DateTime.fromSeconds(e.value);
		} else {
			if (globals.notify.options.length > 0) {
				if (e.value > 0) {
					const tgt_o = globals.notify.options[e.t_id].tgt_list.find(item => item.id === e.value);
					if (!tgt_o) {
						console.error('object for value', e.value, 't_id', e.t_id, 'not found!');

						e.value = 0;
						e.val_obj = null;
					} else {
						e.val_obj = tgt_o;
					}
				} else {
					e.val_obj = null;
				}

				if (!globals.notify.options[e.t_id].tgt_list.find(item => item.id === e.o_id)) {
					e.o_id = 1;
				}
			} else {
				console.error('setNChain called when options not ready!');
			}
		}
	}

	const globals = observable ({
		conn: {
			ws: {},
			conn_level: 0,
			meas_start_time: 0,
			meas_conn_delay: '-',
			connected: false,
			is_auth: false,
			online: false,
			forcedOffline: false,
			initialLoginDone: false,
			new_notifications: false,
			bl_notification: null,
			pts_notification: null,
			sess_id: '',
			user: {},

			setWs: action((ws) => {globals.conn.ws = ws;}),
			setConnLevel: action((level) => {
				if (level > 100) {
					level = 100 
				} else if (level < 0) {
					level = 0;
				}

				globals.conn.conn_level = level;
			}),
			startConnMeas: action(() => {globals.conn.meas_start_time = Date.now();}),
			setConnDelay: action((d) => {globals.conn.meas_conn_delay = d;}),
			setConnected: action((connected) => {globals.conn.connected = connected;}),
			setAuth: action((auth) => {globals.conn.is_auth = auth;}),
			setOnline: action((ol, forced) => {
				if (forced) {
					if (ol) {
						if (globals.conn.connected) {
							globals.conn.online = true;
							globals.conn.forcedOffline = false;
						} else {
							/* Do nothing */
						}
					} else {
						globals.conn.online = false;
						globals.conn.forcedOffline = true;
					}
				} else {
					globals.conn.online = ol;
				}
			}),
			setForceOffline: action((forced) => {globals.conn.forcedOffline = forced;}),
			setInitialLoginDone: action((done) => {globals.conn.initialLoginDone = done;}),
			setSessId: action((id) => {globals.conn.sess_id = id;}),
			setUser: action((user) => {globals.conn.user = user;}),

			setUserTrips: action((t1, t2, t3) => {globals.conn.user.trip1 = t1; globals.conn.user.trip2 = t2; globals.conn.user.trip3 = t3;}),

			setNewNotification: action((is_new) => globals.conn.new_notifications = is_new),
			setBlNotification: action((n) => globals.conn.bl_notification = n),
			setPtsNotification: action((n) => globals.conn.pts_notification = n),
		},

		gps: {
			id: 0,
			available: false,
			pos: {latitude: 0, longitude: 0, accuracy: 0},

			setID: action((id) => {globals.gps.id = id;}),
			setAvailable: action((isAvail) => globals.gps.available = isAvail ? true : false),
			setGpsPos: action((pos) => {globals.gps.pos = pos;}),
		},

		lists: {
			speclist: {},
			citylist: {},
			reglist: {},
			dstlist: [],
			userlist: {},
			triplist: {},
			assolist: {},
			loclist: {},
			full_countrylist: {},
			countrylist: [],

			setSpecList: action((l) => {globals.lists.speclist = l;}),
			setCityList: action((l) => {globals.lists.citylist = l;}),
			setRegList: action((l) => {globals.lists.reglist = l;}),
			setDstList: action((l) => {globals.lists.dstlist = l;}),
			setUserList: action((l) => {globals.lists.userlist = l;}),
			setTripList: action((l) => {
				let _l = [{id:0, name:'add.none',desc:'', user_id:1,public_trip:1,active:1}];
				globals.lists.triplist = {last_upd: l.last_upd,list:_l.concat(l.list)};
			}),
			setAssoList: action((l) => {globals.lists.assolist = l;}),
			setLocList: action((l) => {globals.lists.loclist = l;}),
			setCountryList: action((l) => {
				globals.lists.full_countrylist = l;
				globals.lists.countrylist = l.list.filter(x => (x.id === COUNTRY_ID_FI || x.id === COUNTRY_ID_NO));

				const def_country = globals.lists.countrylist.find(x => x.id === globals.conn.user.def_country);

				if (!globals.stats.country) {
					globals.stats.country = def_country;
				}

				if (!globals.taxons.stat_params.country) {
					globals.taxons.stat_params.country = def_country;
				}
			}),
		},

		srv: {
			info: {},

			setInfo: action((_info) => globals.srv.info = _info)
		},

		splash: {
			loading: false,
			loadDone: false,

			setLoading: action((loading) => {globals.splash.loading = loading;}),
			setLoadDone: action((done) => {globals.splash.loadDone = done;}),
		},

		main: {
			curr_pg: 0,
			n_obs: 0,
			force_load: false,
			loading: false,
			pg_sz: 50,
			edit_obs: null,
// 			obslist: [],

			setCurrPg: action((pg) => {globals.main.curr_pg = pg;}),
			setNObs: action((n_obs) => {globals.main.n_obs = n_obs;}),
			setForceLoad: action((force) => globals.main.force_load = force),
			setLoading: action((loading) => {globals.main.loading = loading;}),
			setEditObs: action((obs) => {globals.main.edit_obs = obs;}),
// 			setObsList: action((list) => {globals.main.obslist = list;}),

			filter: {
				tab: 0,
				place_tab: 0,
				map: null,
				map_w: 0,
				map_h: 0,
				draw_type: 0,
				features: [],

// 				countryList: [],

				active: true,
				changed: false,

				filter: defaultFilter,

				setTab: action((tab) => globals.main.filter.tab = tab),
				setPlaceTab: action((tab) => globals.main.filter.place_tab = tab),
				setMap: action((map) => globals.main.filter.map = map),
				setMapSize: action((w, h) => {
					globals.main.filter.map_w = w;
					globals.main.filter.map.h = h;
				}),
				setDrawType: action((t) => globals.main.filter.draw_type = t),

				setActive: action((act) => globals.main.filter.active = act),
				setChanged: action((ch) => globals.main.filter.changed = ch),
   
				setFilter: action((f) => globals.main.filter.filter = f),
				setFeatures: action((f) => globals.main.filter.features = f),

// 				setCountryList: action((l) => globals.main.filter.countryList = l),
			},
			sorting: {
				primary: 0,	/* 0 = time, 1 = species name, 2 = address, 3 = number  */
				pri_order: 0,	/* 0 = descending, 1 = ascending */

				setPrimarySorting: action((type, order) => {globals.main.sorting.primary = type; globals.main.sorting.pri_order = order;}),
			},
		},

		add: {
			currentStep: 0,

			saveInProg: false,
			cityFetchInProg: false,
			addrFetchInProg: false,

			country: null,
			citylist: null,
			city: null,
			spec: null,

			start_d_str: '',
			start_d_valid: false,
			start_t_str: '',
			start_t_valid: true,

			end_d_str: '',
			end_d_valid: true,
			end_t_str: '',
			end_t_valid: true,

			weather: null,

			obs: {
			},

			personID: [],
			tripID: [],

			regID: 0,

			offlineObsInProg: 0,

			coordAutoChanged: false,
			countryAutoChanged: false,
			cityAutoChanged: false,
			addrAutoChanged: false,
			timeAutoChanged: false,

			map: null,

			from_voice: false,

			/* -------------------------------------------------- */

			setHidden: action((hidden) => {globals.add.obs.hidden = hidden;}),
			setSOState: action((so, state, valid) => {globals.add.obs.subobs[so].sum_desc = state; globals.add.obs.subobs[so].state_valid = valid;}),
			setSOValid: action((so, valid) => {globals.add.obs.subobs[so].state_valid = valid;}),
			setPos: action((lat, long) => {globals.add.obs.lat_obs = lat; globals.add.obs.long_obs = long;}),
			setBirdPos: action((lat, long) => {
				globals.add.obs.lat_tgt = lat; 
				globals.add.obs.long_tgt = long;

				if (!lat || !long) {
					globals.add.obs.fin_br_code = 0;
				}
			}),
			setObsCity: action((id) => {globals.add.obs.city_id = id;}),
			setAddr: action((addr) => {globals.add.obs.addr = addr;}),
			setObsUser: action((id) => {globals.add.obs.user_id = id;}),
			setObsSpec: action((id) => {globals.add.obs.spec_id = id;}),
			setTwitched: action((twitched) => {globals.add.obs.twitched = twitched;}),
			setEco: action((eco) => {globals.add.obs.eco = eco;}),
			setFinBrCode: action((code) => {globals.add.obs.fin_br_code = code;}),
			setColor1: action((c) => {globals.add.obs.color1 = c;}),
			setColor2: action((c) => {globals.add.obs.color2 = c;}),
			setUncertainty: action((u) => {globals.add.obs.uncertainty = u;}),
			setChk1: action((x) => {globals.add.obs.chk1 = x;}),
			setChk2: action((x) => {globals.add.obs.chk2 = x;}),
			setMemo: action((memo) => {globals.add.obs.memo = memo;}),
			setSex: action((sex) => {
				globals.add.obs.subobs.forEach((so, ind) => {
					so.sex = sex;
				})
			}),
			setSONum: action((so, num, n_str) => {
				if (num < 0) {
					num = 0;
					n_str = '0';
				}
				globals.add.obs.subobs[so].num = num; globals.add.obs.subobs[so].num_text = n_str;
			}),
			setSOSex: action((so, sex) => {globals.add.obs.subobs[so].sex_id = sex;}),
			setSOAge: action((so, age) => {globals.add.obs.subobs[so].age_id = age;}),
			setSOPlumage: action((so, plumage) => {globals.add.obs.subobs[so].plumage_id = plumage;}),
			setSOAccuracy: action((so, acc) => {globals.add.obs.subobs[so].acc_id = acc;}),
			setSOMemo: action((so, memo) => {globals.add.obs.subobs[so].memo = memo;}),
			setPersonID: action((id) => {globals.add.personID = id;}),
			setTripID: action((id) => {globals.add.tripID = id;}),
			setRegId: action((id) => {globals.add.regID = id;}),

			/* -------------------------------------------------- */

			setOfflineObsInProg: action((id) => {globals.add.offlineObsInProg = id;}),

			/* -------------------------------------------------- */

			setStep: action((step) => {
				globals.add.currentStep = step;
				globals.add.cityAutoChanged = false;
				globals.add.addrAutoChanged = false;
				globals.add.timeAutoChanged = false;
				globals.add.coordAutoChanged = false;
			}),

			setSaveInProg: action((in_prog) => {globals.add.saveInProg = in_prog;}),
			setCityFetchInProg: action((in_prog) => {globals.add.cityFetchInProg = in_prog;}),
			setAddrFetchInProg: action((in_prog) => {globals.add.addrFetchInProg = in_prog;}),

// 			setCountryList: action((l) => {globals.add.countrylist = l;}),
			setCountry: action((country) => {globals.add.country = country;}),
			setCityList: action((l) => {globals.add.citylist = l;}),
			setCity: action((city) => {globals.add.city = city;}),
			setSpec: action((spec) => {globals.add.spec = spec;}),
			setStartDStr: action((str, valid) => {globals.add.start_d_str = str; globals.add.start_d_valid = valid;}),
			setStartTStr: action((str, valid) => {globals.add.start_t_str = str; globals.add.start_t_valid = valid;}),

			setWeather: action((w) => {globals.add.weather = w;}),
			setObs: action((obs) => {globals.add.obs = obs;}),

			setCoordAutoChanged: action((ac) => {globals.add.coordAutoChanged = ac;}),
			setCountryAutoChanged: action((ac) => {globals.add.countryAutoChanged = ac;}),
			setCityAutoChanged: action((ac) => {globals.add.cityAutoChanged = ac;}),
			setAddrAutoChanged: action((ac) => {globals.add.addrAutoChanged = ac;}),
			setTimeAutoChanged: action((ac) => {globals.add.timeAutoChanged = ac;}),
    
			setMap: action((map) => {globals.add.map = map;}),

			setFromVoice: action ((from_voice) => {globals.add.from_voice = from_voice;}),
		},

		settings: {
			em: EM_SELF,
			id: 0,

			/* -------------------------------------------------- */

			setEditMode: action((em) => {if (em < EM_SELF) em = EM_SELF; if (em > EM_OTHER) em = EM_SELF; globals.settings.em = em;}),
			setEditId: action((id) => {globals.settings.id = id;})
		},

		trips: {
			trip: {},		/* item under editing */
			changed: false,		/* item edited */
			stats: [],		/* trip statistics */

			/* -------------------------------------------------- */

			setTrip: action((t) => {globals.trips.trip = t;}),
			newTrip: action((changed) => {
				globals.trips.trip = {id:0, user_id:globals.conn.user.id,name:isoDStr(unixNow()),desc:'',public_trip:1,active:1,all_reported:0}; 
			}),
			setChanged: action((c) => {globals.trips.changed = c;}),
			setStats: action((s) => {globals.trips.stats = s;}),
		},

		destination: {
			dest: {},		/* item under editing */
			city: null,
			modified: false,	/* item edited */

			latStr: '',
			longStr: '',

			/* -------------------------------------------------- */

			setDestination: action((d, modified) => {
				globals.destination.dest = d;
				globals.destination.city = globals.lists.citylist.list.find((city) => city.id === d.city_id);
				globals.destination.latStr = getCoordStr(d.lat_obs);
				globals.destination.longStr = getCoordStr(d.long_obs);
				globals.destination.modified = modified;
			}),

			newDestination: action((modified) => {
				globals.destination.setDestination({
					id: 0, city_id: CITY_ID_FORSSA, reg_type: 1, 
					name:'', address:'', description:'',
					lat_obs:0, long_obs:0, public_loc: 1,
					user_id: globals.conn.user.id}, 
					modified); 
			}),
			setCity: action((city) => {
				globals.destination.city = city;
				globals.destination.dest.city_id = city.id;
			}),
		},

		location: {
			loc: {
				cities: []
			},		/* item under editing */

			modified: false,

			setLocation: action((loc, mod = true) => {
				globals.location.loc = loc;
				globals.location.modified = mod;
// 				console.log('setLocation', globals.location.loc, globals.location.modified);
			}),

			newLocation: action(() => {
				globals.location.setLocation({
					id: 0,
					user_id: globals.conn.user.id,
					loct_id: LOCT_UNDEF,
					tgt_id: 0,
					address: '',
					name: '',
					cities: []
				}, true);
			}),
		},

		stats: {
			tab: 0,
			obsList: null,

			time_tab: TAB_YEAR,
			loc_tab: TAB_CITY,
			spec_tab: TAB_LIFER,
			other_tab: TAB_OBS_COUNT,
			missing_tab: TAB_CITY_MISSING,

			country: null,				/* all stats */
			city: null,

			year: new Date().getYear() + 1900,	/* year stats only (can't be 0) */
			statsYear: 0,				/* all the rest (can be 0) */

			dailyDate: DateTime.now(),		/* Daily stats date */

			month_tab: 0,
			month: 0,

			date_tab: new Date().getMonth(),	/* date stats selected month */
			dateMissingDate: DateTime.now(),	/* date missing date */

			location: 0,

			trip: 0,
			trip_sort_order: 0,	/* key (=time), cnt, num */
			trip_sort_dir: 0,	/* desc/asc */
			
			city_tab: 0,
			city_sort_order: 0,	/* spec, n_spec, n_obs, count */
			city_sort_dir: 0,	/* desc/asc */

			taxon_sort_order: 0,	/* spec, n_cities, n_obs, count */
			taxon_sort_dir: 0,	/* desc/asc */

			lifer_tab: 0,
			lifer_sort_order: 0,	/* city, count */
			lifer_sort_dir: 0,	/* desc/asc */
			
			obs_cnt_tab: 0,

			association: 0,		/* stats asso tab */

			leftList: {tab: 0, year: 0, month:0, location: -1, list: []},
			rightList: {tab: 0, year: 0, month:0, location: -1, list: []},

			/* -------------------------------------------------- */

			setTab: action((tab) => {globals.stats.tab = tab;}),
			setObsList: action((list) => {globals.stats.obsList = list;}),

			setCountry: action((c) => {globals.stats.country = c;}),
			setCity: action((c) => {globals.stats.city = c;}),
	    
			setYear: action((y) => {globals.stats.year = y;}),
			setStatsYear: action((y) => {globals.stats.statsYear = y;}),

			setDailyDate: action((dt) => {globals.stats.dailyDate = dt;}),

			setMonthTab: action((tab) => {globals.stats.month_tab = tab;}),
			setMonth: action((m) => {globals.stats.month = m;}),

			setDateTab: action((tab) => {globals.stats.date_tab = tab;}),
			setDateMissingDate: action((dt) => {globals.stats.dateMissingDate = dt;}),

			setMissingTab: action((tab) => {globals.stats.missing_tab = tab;}),

			setLocation: action((l) => {globals.stats.location = l;}),

			setTrip: action((t) => {globals.stats.trip = t;}),
			setTripOrder: action((o, d) => {globals.stats.trip_sort_order = o; globals.stats.trip_sort_dir = d;}),

			setCityTab: action((tab) => {globals.stats.city_tab = tab;}),
			setCityOrder: action((o, d) => {globals.stats.city_sort_order = o; globals.stats.city_sort_dir = d;}),

			setTaxonOrder: action((o, d) => {globals.stats.taxon_sort_order = o; globals.stats.taxon_sort_dir = d;}),

			setLiferTab: action((tab) => {globals.stats.lifer_tab = tab;}),
			setLiferOrder: action((o, d) => {globals.stats.lifer_sort_order = o; globals.stats.lifer_sort_dir = d;}),

			setTimeTab: action((tab) => {globals.stats.time_tab = tab;}),
			setLocTab: action((tab) => {globals.stats.loc_tab = tab;}),
			setSpecTab: action((tab) => {globals.stats.spec_tab = tab;}),
			setOtherTab: action((tab) => {globals.stats.other_tab = tab;}),

			setObsCntTab: action((tab) => {globals.stats.obs_cnt_tab = tab;}),

			setAssociation: action((tab) => {globals.stats.association = tab;}),

			setLeftList: action((ll) => {globals.stats.leftList = {...ll, country: globals.stats.country ? globals.stats.country.id : 0};}),
			setRightList: action((rl) => {globals.stats.rightList = {...rl, country: globals.stats.country ? globals.stats.country.id : 0};}),
		},

		taxons: {
			tab: 0,

			pendTaxon: null,

			/* Taxonomy tab */
			upperTaxon4: null,
			upperTaxon3: null,
			upperTaxon2: null,
			upperTaxon1: null,
			centerTaxon: null,
			childList: [],

			/* Description tab */
			desc: null,
			descChanged: false,

			/* BL tab */
			bl: null,

			/* Statistics tab */
			stat_tab: 0,
			gen_stats: null,
			stats: null,
			month_stats: null,
			year_stats: null,
			date_stats: null,

			stat_params: {
				country: 0,
				year: 0,

				setCountry: action((value) => {globals.taxons.stat_params.country = value;}),
				setYear: action((value) => {globals.taxons.stat_params.year = value;}),
			},

			/* Media tab */
			mediaList: null,
			loadPos: 0,
			editMedia: null,

			/* Map tab */
			obslist: null,
			map: null,
			obsLayer: null,
			obsStyle: 1,
			mapWidth: 0,
			mapHeight: 0,

			/* Halias tab */
			halias_data: null,

			/* Atlas tab */
			atlas_data: null,
			atlas_map: null,
			atlas_layer: null,
			atlas_map_width: 0,
			atlas_map_height: 0,
			atlas_style: 0,
			atlas_obs: null,

			/* Migration  tab */
			migr: null,

			/* References tab */
			refs: null,
			
			/* -------------------------------------------------- */

			setTab: action((tab) => globals.taxons.tab = tab),

			setPendTaxon: action((t) => globals.taxons.pendTaxon = t),

			setUpperTaxon4: action((t) => globals.taxons.upperTaxon4 = t),
			setUpperTaxon3: action((t) => globals.taxons.upperTaxon3 = t),
			setUpperTaxon2: action((t) => globals.taxons.upperTaxon2 = t),
			setUpperTaxon1: action((t) => globals.taxons.upperTaxon1 = t),
			setCenterTaxon: action((t) => globals.taxons.centerTaxon = t),

			setChildList: action((cl) => globals.taxons.childList = cl),

			/* -------------------------------------------------- */

			/* Desc tab */
			setDesc: action((desc) => {
				globals.taxons.desc = desc;
			}),
			setDescChanged: action((changed) => {
				globals.taxons.descChanged = changed;
			}),

			/* BL tab */
			setBl: action((bl) => {
				globals.taxons.bl = bl;
			}),

			/* Statistics tab */
			setStatsTab: action((tab) => {
				globals.taxons.stat_tab = tab;
			}),

			setGenStats: action((stats) => {
				globals.taxons.gen_stats = stats;
			}),

			setStats: action((stats) => {
				globals.taxons.stats = stats;
			}),

			setMonthStats: action((stats) => {
				globals.taxons.month_stats = stats;
			}),

			setYearsStats: action((stats) => {
				globals.taxons.year_stats = stats;
			}),

			setDateStats: action((stats) => {
				globals.taxons.date_stats = stats;
			}),

			/* Media tab */
			setMediaList: action((list) => {
// 				console.log('setMediaList', list);
				globals.taxons.mediaList = list;
			}),

			setLoadPos: action((_pos) => {
				if (!globals.taxons.mediaList) {
					globals.taxons.loadPos = 0;
					return;
				}

				if (_pos > globals.taxons.mediaList.length)
					_pos = globals.taxons.mediaList.length;

				if (_pos < 0)
					_pos = 0;

				globals.taxons.loadPos = _pos;
			}),

			setMediaSrc: action((pos, file_content) => {
				if (!globals.taxons.mediaList) {
					console.error('setMediaSrc: no media!');
					return;
				}

				if (pos < 0 || pos >= globals.taxons.mediaList.length) {
					console.error('setMediaSrc: invalid position', pos, '! Expected 0-', 
						globals.taxons.mediaList.length);
					return;
				}

				let mt ='';

				if (globals.taxons.mediaList[pos].mt_id === MTI_JPG) {
					mt = 'image/jpeg';
				} else if (globals.taxons.mediaList[pos].mt_id === MTI_PNG) {
					mt = 'image/png';
				} else {
					console.error('setMediaSrc: invalid media type', 
						globals.taxons.mediaList[pos].mt_id, '!');
					return;
				}

				globals.taxons.mediaList[pos].src = 'data:' + mt + ';base64,' + file_content;
			}),

			setEditMedia: action((media) => {
				if (media) {
					globals.taxons.editMedia = JSON.parse(JSON.stringify(media));
					delete globals.taxons.editMedia.src;
				} else {
					globals.taxons.editMedia = null;
				}
			}),

			editMediaToMediaList: action((pos) => {
				if (!globals.taxons.mediaList) {
					console.error('editMediaToMediaList: no list!');
					return;
				}

				if (!globals.taxons.editMedia) {
					console.error('editMediaToMediaList: no edit media!');
					return;
				}

				if (pos < 0 || pos >= globals.taxons.mediaList.length) {
					console.error('editMediaToMediaList: invalid position', pos, '! Expected 0-', 
						globals.taxons.mediaList.length);
					return;
				}

				globals.taxons.mediaList[pos] = Object.assign(globals.taxons.mediaList[pos], globals.taxons.editMedia);
				globals.taxons.editMedia = null;
			}),

			/* Map tab */
			setObsList: action((obs) => globals.taxons.obslist = obs),
			setMap: action((map, layer) => {globals.taxons.map = map; globals.taxons.obsLayer = layer;}),
			setObsStyle: action((s) => globals.taxons.obsStyle = s),
			setMapSize: action((w, h) => {globals.taxons.mapWidth = w; globals.taxons.mapHeight = h}),
	    
			/* Halias tab */
			setHaliasData: action((hd) => globals.taxons.halias_data = hd),

			/* Atlas tab */
			setAtlasData: action((ad) => {
				globals.taxons.atlas_data = ad;
				if (!ad) {
					globals.taxons.atlas_style = 0;
					globals.taxons.atlas_obs = null;
				}
			}),
			setAtlasMap: action((map, layer) => {globals.taxons.atlas_map = map; globals.taxons.atlas_layer = layer;}),
			setAtlasMapSize: action((w, h) => {globals.taxons.atlas_map_width = w; globals.taxons.atlas_map_height = h}),
			setAtlasStyle: action((s) => globals.taxons.atlas_style = s),
			setAtlasObs: action((obs) => globals.taxons.atlas_obs = obs),

			/* Migration tab */
			setMigration: action((mi) => globals.taxons.migr = mi),

			/* References tab */
			setReferences: action((refs) => globals.taxons.refs = refs),
		},

		notify: {
			nchain: [],		/* Full notification table */
			options: [],		/* Detail values by type */
			notification: {},	/* Item under editing */
			nlist: [],		/* List of notifications */

			/* Full list of notification chains */
			setNChain: action((chain) => {
				chain.forEach((c, ind) => {
					c.elem.forEach((e, ind) => {
						cleanElem(e);
					});
				});

				globals.notify.nchain = chain;
			}),

			/* Option list */
			setOptionArray: action((options) => globals.notify.options = options),

			/* Chain */
			setEditTarget: action((ch) => globals.notify.notification = JSON.parse(JSON.stringify(globals.notify.nchain[ch]))),
			newEditTarget: action(() => globals.notify.notification = {id:0,desc:'',active:1,modified:1,elem:[]}),
			extEditTarget: action((chain) => globals.notify.notification = chain),
			clrEditTarget: action(() => globals.notify.notification = {}),

			setTgtDesc: action((desc) => {
				globals.notify.notification.desc = desc;
				globals.notify.notification.modified = 1;
			}),
			setTgtActive: action((ch, act) => globals.notify.nchain[ch].active = act),

			/* Element */
			setTgtEType: action((elem, type) => {
				let e = globals.notify.notification.elem[elem];

				console.log('setTgtEType begin: elem', elem, 'type', type);

				e.t_id = type;
				cleanElem(e);
				globals.notify.notification.modified = 1;

				console.log('setTgtEType end: e.t_id', e.t_id, 'value', e.value, 'obj', e.val_obj);
			}),
			setTgtEOp: action((elem, op) => {
				globals.notify.notification.elem[elem].o_id = op;
				globals.notify.notification.modified = 1;
			}),
			setTgtEValue: action((elem, value) => {
				globals.notify.notification.modified = 1;

				if (!value) {
					globals.notify.notification.elem[elem].value = 0;
					globals.notify.notification.elem[elem].value = null;
					return;
				}

				globals.notify.notification.elem[elem].value = value.id;
				globals.notify.notification.elem[elem].val_obj = value;
			}),
			setTgtEDate: action((elem, dt) => {
				let sec = Math.round(dt.toSeconds());

				sec -= (sec % (24*3600));

				globals.notify.notification.elem[elem].value = sec;
				globals.notify.notification.elem[elem].val_obj = DateTime.fromSeconds(sec);
				globals.notify.notification.modified = true;
			}),
			setTgtEMonth: action((elem, m) => {
				let ne = globals.notify.notification.elem[elem];

				ne.value &= 0x00ff;
				ne.value |= ((m & 0xff) << 8);

				cleanElem(ne);
				globals.notify.notification.modified = 1;
			}),
			setTgtEDay: action((elem, m) => {
				let ne = globals.notify.notification.elem[elem];

				ne.value &= 0xff00;
				ne.value |= (m & 0xff);

				cleanElem(ne);
				globals.notify.notification.modified = 1;
			}),
			setTgtETime: action((elem, dt) => {
				let sec = Math.round(dt.toSeconds());

				sec = (sec % (24*3600));

				globals.notify.notification.elem[elem].value = sec;
				globals.notify.notification.elem[elem].val_obj = DateTime.fromSeconds(sec);
				globals.notify.notification.modified = 1;

				console.log('e.value', globals.notify.notification.elem[elem].value);
			}),
			setTgtEActive: action((elem, active) => {
				globals.notify.notification.elem[elem].active = active ? 1 : 0;
				globals.notify.notification.modified = 1;
			}),

			/* List of notifications */
			setNList: action((l) => {
				globals.notify.nlist = l;
			}),
		},

		calendar: {
			dt: null,		/* Target timestamp */
			dates: null,		/* Result array */
			migr_type: 0,
			change_type: 0,
			jam_time: 0,
			pre_time: 7,

			setDt: action((dt) => globals.calendar.dt = dt),
			setDates: action((d) => globals.calendar.dates = d),
			setMigrType: action((mt) => globals.calendar.migr_type = mt),
			setChangeType: action((ct) => globals.calendar.change_type = ct),
			setJamTime: action((jt) => globals.calendar.jam_time = jt),
		},

		dayrep: {
			stats: null,
			
			setStats: action((stats) => globals.dayrep.stats = stats)
		},
		
		/* Single map object to replace many different ones here and there */
		map: {
			map: null,
			obsLayer: null,
			mapWidth: 0,
			mapHeight: 0,

			list: [],	/* appbar */
			header: '',	/* --""--*/

			setMap: action((map, layer) => {globals.map.map = map; globals.map.obsLayer = layer;}),
			setMapSize: action((w, h) => {globals.map.mapWidth = w; globals.map.mapHeight = h;}),

			setList: action((list) => globals.map.list = list),
			setHeader: action((header) => globals.map.header = header),
		}, 

		speechRec: {
			recognizer: null,
			isRecording: false,

			setRecognizer: action((recognizer) => {globals.speechRec.recognizer = recognizer;}),
			setIsRecording: action((isRecording) => {globals.speechRec.isRecording = isRecording;})
		}
	});

	return globals;
}

export const GlobalProvider = ({children}) => {
	const gStorage = useLocalObservable(createGlobalStorage);

	return <GlobalContext.Provider value={gStorage}> 
			{children}
		</GlobalContext.Provider>
}

export const useGlobalStorage = () => useContext(GlobalContext);
